import copy from 'copy-to-clipboard';
import toast from 'react-hot-toast';

export const detectKeyPress = (e: any) => {
  const returnobj: any = {};
  if ('key' in e) {
    switch (e.key) {
      case 'Escape':
      case 'Esc':
        {
          returnobj['escape'] = true;
        }
        break;
      case 'ArrowLeft':
        {
          returnobj['leftarrow'] = true;
        }
        break;
      case 'ArrowUp':
        {
          returnobj['uparrow'] = true;
        }
        break;
      case 'ArrowRight':
        {
          returnobj['rightarrow'] = true;
        }
        break;
      case 'ArrowDown':
        {
          returnobj['downarrow'] = true;
        }
        break;
      case 'Enter': {
        returnobj['enter'] = true;
        break;
      }
      case 'Backspace':
        {
          returnobj['Backspace'] = true;
        }
        break;
      default:
    }
  } else {
    switch (e.keyCode) {
      case 27:
      case '27':
        {
          returnobj['escape'] = true;
        }
        break;
      case 37:
      case '37':
        {
          returnobj['leftarrow'] = true;
        }
        break;
      case 38:
      case '38':
        {
          returnobj['uparrow'] = true;
        }
        break;
      case 39:
      case '39':
        {
          returnobj['rightarrow'] = true;
        }
        break;
      case 40:
      case '40':
        {
          returnobj['downarrow'] = true;
        }
        break;
      case 13:
      case '13':
        {
          returnobj['enter'] = true;
        }
        break;
      default:
    }
  }
  return returnobj;
};

export const copyToClipboard = (textToCopy: string, successMsg?: string) => {
  const didCopy = copy(textToCopy);
  if (didCopy) {
    toast.success(successMsg ?? 'Copied to clipboard!');
  }
  return textToCopy;
};

export const openInNewTab = (url: string) => {
  const win = window.open(url, '_blank');
  if (win) {
    win.focus();
  }
};

export const hasErrorFields = (id?: string): boolean => {
  const root = id ? document.getElementById(id) : document;
  return !!root?.querySelectorAll('.error-field').length;
};

export const toFloat = (value: string | number): number => {
  if (typeof value === 'number') return value;

  const num = parseFloat(value.trim());
  return isNaN(num) ? 0 : num;
};

export const getTextColor = (bgColor: string) => {
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#000' : '#fff';
};
